export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';

export const UPLOAD_EXTRA_REQUEST = 'UPLOAD_EXTRA_REQUEST';
export const UPLOAD_EXTRA_SUCCESS = 'UPLOAD_EXTRA_SUCCESS';
export const UPLOAD_EXTRA_FAILURE = 'UPLOAD_EXTRA_FAILURE';

